export class WebEpisode{
    episode :boolean = false;
    type:string
    text: string
}